<abc-accordion
  class="accordion-style container"
  [collapsible]="true"
  [selectedIndex]="-1"
  [width]="'100%'"
  [animationDuration]="300"
  [visible]="true"
  [multiple]="false"
  [dataSource]="['Test']"
>
  <div *dxTemplate="let company of 'title'" class="dx-accordion-item-title">
    {{ this.dataService.res('Ubt-MeasureDetail-Status-Report') }}
  </div>

  <div fxLayout="column" fxLayoutGap="15px" class="card-paddings container-card" *dxTemplate="let company of 'item'">
    <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="10px">
      <div fxLayoutAlign="start">
        <ng-container>
          <div fxLayout="row">
            <img class="date-start-style" src="assets/images/dateStart.svg" />
            <div *ngIf="lastMeasureProgress.ProgressDate">
              {{ convertHelper.toDate(lastMeasureProgress?.ProgressDate?.toString()) }}  {{lastMeasureProgress['Properties'] ? lastMeasureProgress['Properties'][0]['Designation'] : '' }}
            </div>
            <div *ngIf="!lastMeasureProgress.ProgressDate">{{ convertHelper.toDate(date) }}</div>
          </div>
        </ng-container>
      </div>
      <div fxLayoutAlign="end">
        <abc-check-box
          class="check-box-style"
          [(value)]="workOnLastStatus"
          [height]="'100%'"
          [width]="'100%'"
          [disabled]="isNewMeasureTask || measureProgress?.length === 0 ||!canManageStatusReport"
          text="{{ dataService.res('Ubt-MeasureDetail-Duplicate-Content') }}"
        >
        </abc-check-box>
        <div>
          <abc-button
            [stylingMode]="'text'"
            [icon]="'assets/images/plus.svg'"
            [type]="'normal'"
            [hint]="dataService.res('Ubt-MeasureDetail-New-Status')"
            (onClick)="clearProgressFileds()"
            [disabled]="isNewMeasureTask || measureProgress.length === 0 ||!canManageStatusReport"
            [height]="'100%'"
          >
          </abc-button>
        </div>

        <abc-button
          [stylingMode]="'text'"
          [icon]="'assets/images/Delete.svg'"
          [type]="'normal'"
          [hint]="dataService.res('Ubt-MeasureDetail-Delete')"
          class="assgin-progress-button"
          (onClick)="openConfirmTaskDialog()"
          [disabled]="measureProgress.length == 0 || !lastMeasureProgress.Id || IsRoleAuthorizedToUpdateDate()"
          [height]="'100%'"
        >
        </abc-button>
        <abc-button
          [stylingMode]="'text'"
          [icon]="'assets/images/save.svg'"
          [type]="'normal'"
          class="assgin-progress-button"
          [hint]="dataService.res('Ubt-MeasureDetail-Save')"
          [height]="'100%'"
          (onClick)="persistStatusReport()"
          [disabled]="disableSave||!canManageStatusReport"
        >
        </abc-button>
        <abc-button
          stylingMode="text"
          [icon]="'assets/images/navigate_left.svg'"
          type="default"
          [hint]="dataService.res('Ubt-Navigation-Previous')"
          [disabled]="
            this.appService.currentMeasureProgressIndex === 0 ||
            appService.currentMeasureProgressIndex === -1 ||
            measureProgress.length === 1 ||
            measureProgress.length === 0 ||
            isNewMeasureTask
          "
          (onClick)="navigateToMeasureProgress(-1)"
          [hoverStateEnabled]="false"
        >
        </abc-button>
        <abc-button
          stylingMode="text"
          [icon]="'assets/images/navigate_right.svg'"
          type="default"
          [hint]="dataService.res('Ubt-Navigation-Next')"
          [disabled]="
            this.appService.currentMeasureProgressIndex === measureProgress?.length - 1 ||
            this.appService.currentMeasureProgressIndex === -1 ||
            measureProgress.length === 1 ||
            measureProgress.length === 0 ||
            isNewMeasureTask
          "
          (onClick)="navigateToMeasureProgress(1)"
          [hoverStateEnabled]="false"
        >
        </abc-button>
      </div>
    </div>
    <div fxLayout="row" fxLayoutGap="15px">
      <div fxFlex="50" fxLayout="column">
        <div fxLayout="row" fxLayoutAlign="space-between">
          <span class="html-editor-title-style">{{ dataService.res('Ubt-MeasureDetail-Progress') }}</span>
          <span
            fxLayout="row"
            class="dx-icon-edit edit-button-style"
            (click)="openPopup(lastMeasureProgress.Progress, 'Progress')"
          ></span>
        </div>
        <dx-html-editor
          fxLayout="row"
          height="200px"
          class="background-white"
          [(value)]="lastMeasureProgress.Progress"
          (onFocusIn)="focusIn(lastMeasureProgress.Progress)"
          [disabled]="IsRoleAuthorizedToUpdateDate()"
          (onValueChanged)="verifyChanges($event, lastMeasureProgress.Progress, 'Progress')"
        >
        </dx-html-editor>
      </div>
      <div fxFlex="50" fxLayout="column">
        <div fxLayout="row" fxLayoutAlign="space-between">
          <span class="html-editor-title-style">{{ dataService.res('Ubt-MeasureDetail-Next-Steps') }}</span>
          <span
            fxLayout="row"
            class="dx-icon-edit edit-button-style"
            (click)="openPopup(lastMeasureProgress.NextSteps, 'NextSteps')"
          ></span>
        </div>

        <dx-html-editor
          fxLayout="row"
          height="200px"
          class="background-white"
          [(value)]="lastMeasureProgress.NextSteps"
          (onFocusIn)="focusIn(lastMeasureProgress.NextSteps)"
          [disabled]="IsRoleAuthorizedToUpdateDate()"
          (onValueChanged)="verifyChanges($event, lastMeasureProgress.NextSteps, 'NextSteps')"
        >
        </dx-html-editor>
      </div>
    </div>
    <div fxLayout="row" fxLayoutGap="15px">
      <div fxFlex="50" fxLayout="column">
        <div fxLayout="row" fxLayoutAlign="space-between">
          <span class="html-editor-title-style">{{ dataService.res('Ubt-MeasureDetail-Risks-Opportunities') }}</span>
          <span
            fxLayout="row"
            class="dx-icon-edit edit-button-style"
            (click)="openPopup(lastMeasureProgress.RiskAndChance, 'RiskAndChance')"
          ></span>
        </div>

        <dx-html-editor
          fxLayout="row"
          height="200px"
          class="background-white"
          [(value)]="lastMeasureProgress.RiskAndChance"
          (onFocusIn)="focusIn(lastMeasureProgress.RiskAndChance)"
          [disabled]="IsRoleAuthorizedToUpdateDate()"
          (onValueChanged)="verifyChanges($event, lastMeasureProgress.RiskAndChance, 'RiskAndChance')"
        >
        </dx-html-editor>
      </div>
      <div fxFlex="50" fxLayout="column">
        <div fxLayout="row" fxLayoutAlign="space-between">
          <span class="html-editor-title-style">{{ dataService.res('Ubt-MeasureDetail-Decision-Clarification') }}</span>
          <span
            fxLayout="row"
            class="dx-icon-edit edit-button-style"
            (click)="openPopup(lastMeasureProgress.Decision, 'Decision')"
          ></span>
        </div>

        <dx-html-editor
          fxLayout="row"
          height="200px"
          class="background-white"
          [(value)]="lastMeasureProgress.Decision"
          (onFocusIn)="focusIn(lastMeasureProgress.Decision)"
          [disabled]="IsRoleAuthorizedToUpdateDate()"
          (onValueChanged)="verifyChanges($event, lastMeasureProgress.Decision, 'Decision')"
        >
        </dx-html-editor>
      </div>
    </div>

    <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="10px">
      <div fxFlex="33">
        <abc-number-box
          #progressField
          [(value)]="lastMeasureProgress.ProgressPercentage"
          [stylingMode]="'outlined'"
          [format]="dataService.customizePercentageText"
          [label]="dataService.res('Ubt-MeasureDetail-Chart-Progress')"
          [labelMode]="'floating'"
          [disabled]="IsRoleAuthorizedToUpdateDate()"
          (onValueChanged)="verifyChanges($event, 'ProgressPercentage')"
        >
        </abc-number-box>
      </div>
      <div fxFlex="33" fxLayoutAlign="start center">
        <abc-select-box
          class="drop-down-style"
          [stylingMode]="'outlined'"
          [width]="'100%'"
          [height]="'100%'"
          [(value)]="lastMeasureProgress.MaturityLevel"
          [dataSource]="measureService.maturityLevel"
          [label]="dataService.res('Ubt-MeasureDetail-Maturity-Level')"
          [labelMode]="'floating'"
          displayExpr="name"
          valueExpr="value"
          [disabled]="IsRoleAuthorizedToUpdateDate()"
          (onValueChanged)="verifyChanges($event, 'MaturityLevel')"
        >
        </abc-select-box>
      </div>
      <div fxFlex="33">
        <h4 *ngIf="lastMeasureProgress.MaturityLevel">
          {{ lastMeasureProgress.MaturityLevel }}:
          {{ dataService.res('Ubt-MeasureDetail-' + lastMeasureProgress.MaturityLevel) }}
        </h4>
      </div>
    </div>
  </div>
</abc-accordion>

<abc-popup
  #confirmDeletePopup
  [width]="'25%'"
  fxLayout="column"
  fxLayoutAlign="center center"
  [height]="'auto'"
  [title]="dataService.res('Ubt-MeasureList-Confirm-Delete')"
  [showCloseButton]="true"
>
  <div
    class="dx-card popup-card-paddings card-radius"
    fxLayout="column"
    fxLayoutAlign="center center"
    fxLayoutGap="20px"
  >
    <div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="20px">
      {{ dataService.res('Ubt-MeasureList-Delete-Message') }}
    </div>

    <dxi-item itemType="group" fxLayout="row" fxLayoutAlign="end end" fxLayoutGap="20px">
      <abc-button
        class="submit-button"
        [text]="dataService.res('Ubt-Company-Icon-Delete')"
        [text]="dataService.res('Ubt-MeasureList-Yes')"
        (onClick)="deleteStatusReport()"
      >
      </abc-button>
      <abc-button class="cancel-button" [text]="dataService.res('Ubt-MeasureList-No')" (onClick)="abortTaskDelete()">
      </abc-button>
    </dxi-item>
  </div>
</abc-popup>

<abc-popup
  [height]="540"
  [width]="'50%'"
  [(visible)]="toogleTitleVisible"
  [resizeEnabled]="true"
  title="{{ dataService.res('Ubt-Measure-Detail-Html-Editor-Title') }}"
>
  <div class="dx-card popup-card-paddings card-radius" fxLayout="column" fxLayoutGap="10px">
    <div fxLayout="row">
      <div fxLayout="column" fxFlex="95">
        {{ dataService.res('Ubt-Html-Editor-' + propertyName) }}
      </div>
      <div fxLayout="column" fxFlex="5">
        <abc-button
          class="edit-text"
          type="default"
          [icon]="'save'"
          [hint]="'Save'"
          [disabled]="IsRoleAuthorizedToUpdateDate()"
          (onClick)="saveChanges(propertyName, fieldValue)"
        >
        </abc-button>
      </div>
    </div>
    
    <div fxLayout="row">
      <dx-html-editor
        #htmlEditor
        height="350px"
        [width]="'100%'"
        (onValueChanged)="verifyChanges($event, fieldValue)"
        [(value)]="fieldValue"
        [disabled]="IsRoleAuthorizedToUpdateDate()"
        class="html-editor-style"
      >
        <dxo-toolbar [multiline]="false">
          <dxi-item name="undo"></dxi-item>
          <dxi-item name="redo"></dxi-item>
          <dxi-item name="color"></dxi-item>
          <dxi-item name="bold"></dxi-item>
          <dxi-item name="italic"></dxi-item>
          <dxi-item name="strike"></dxi-item>
          <dxi-item name="underline"></dxi-item>
          <dxi-item name="alignLeft"></dxi-item>
          <dxi-item name="alignCenter"></dxi-item>
          <dxi-item name="alignRight"></dxi-item>
          <dxi-item name="alignJustify"></dxi-item>
          <dxi-item name="orderedList"></dxi-item>
          <dxi-item name="bulletList"></dxi-item>
          <dxi-item name="insertTable"></dxi-item>
          <dxi-item name="deleteTable"></dxi-item>
          <dxi-item name="insertRowBelow"></dxi-item>
        </dxo-toolbar>
      </dx-html-editor>
    </div>
  </div>
</abc-popup>
